/**
 * Dashboard → Announcements — the news, and only the news (ADR-0137).
 *
 * Renamed from "Headlines" (that page name is retired): the operator
 * announcements block — "what's new and how the system works," the
 * material LegalFlare staff prep from. No numbers live here (the
 * measurement board was wiped by #740 and is rebuilt from the
 * Contract). Per-department signal headlines
 * land on this surface later (the signals framework — deviations and
 * events, never standing numbers).
 */

import { DashboardNav } from "@/components/dashboard-nav";
import { AnnouncementsBlock } from "@/components/announcements-block";

export function AnnouncementsPage() {
  return (
    <section
      className="mx-auto flex max-w-4xl flex-col gap-6 p-6"
      data-testid="dashboard-announcements"
    >
      <DashboardNav active="announcements" />
      <AnnouncementsBlock />
    </section>
  );
}
